import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "page-wrapper",
  id: "tools-home-main-content",
  tabindex: "-1"
}
const _hoisted_2 = {
  key: 0,
  class: "content-frame-wrapper",
  "data-test": "resume-wrapper"
}
const _hoisted_3 = { class: "title-wrapper" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "page-description" }
const _hoisted_6 = {
  key: 1,
  class: "content-frame-wrapper"
}
const _hoisted_7 = { class: "headings-skeleton-wrapper" }
const _hoisted_8 = { class: "cards-skeleton-wrapper" }
const _hoisted_9 = {
  key: 2,
  class: "content-frame-wrapper"
}
const _hoisted_10 = { class: "title-wrapper" }
const _hoisted_11 = { class: "page-title" }
const _hoisted_12 = { class: "page-description" }
const _hoisted_13 = {
  key: 3,
  class: "content-frame-wrapper",
  "data-test": "empty-tools-page"
}
const _hoisted_14 = {
  id: "page-title-empty",
  class: "page-title"
}
const _hoisted_15 = {
  id: "page-description-empty",
  class: "page-description"
}
const _hoisted_16 = { class: "button-wrapper" }

import { IonPage, IonContent, onIonViewDidEnter } from "@ionic/vue";
import MobileHeader from "@/components/Common/MobileHeader/MobileHeader.vue";
import DesktopLocaleSelector from "@/components/Common/LocaleSelector/DesktopLocaleSelector.vue";
import ContentBanner from "@/components/Common/ContentBanner/ContentBanner.vue";
import { useAssessmentStore, useFeatureFlagStore } from "@/store";
import AssessmentCards from "@/components/Assessment/AssessmentCards/AssessmentCards.vue";
import CardSkeleton from "@/components/Skeletons/CardSkeleton/CardSkeleton.vue";
import DescriptionSkeleton from "@/components/Skeletons/DescriptionSkeleton/DescriptionSkeleton.vue";
import TitleSkeleton from "@/components/Skeletons/TitleSkeleton/TitleSkeleton.vue";
import { computed, onMounted, ref } from "vue";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import CardPortrait from "@/components/Common/CardPortrait/CardPortrait.vue";
import { CardContent } from "@/store/models/card.models";
import { documentTextOutline } from "ionicons/icons";
import { useRoute } from "vue-router";
//TODO: Maybe we move this somewhere global??
import { useI18n } from "vue-i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'ToolsHome',
  setup(__props) {

const { t } = useI18n<{}>({
  useScope: "global",
});

const resumeBuilderCTA: CardContent = {
  title: t("resume.resumeCard.title"),
  description: t("resume.resumeCard.description"),
  icon: documentTextOutline,
};

const featureFlagStore = useFeatureFlagStore();
const assessmentStore = useAssessmentStore();
const route = useRoute();
const pageTitle = ref((route?.meta.title as string) || "");

onIonViewDidEnter(() => {
  pageTitle.value = route?.meta.title || "";
});

const isAssessmentsLoaded = computed(() => {
  return assessmentStore.isAssessmentsLoaded;
});
const assessmentsExist = computed(() => {
  if (!featureFlagStore.isFlagEnabled("release-component-assessments", false)) {
    return false;
  }
  return assessmentStore.getAssessments.length > 0;
});
onMounted(async (): Promise<void> => {
  await assessmentStore.requestAssessments();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(MobileHeader),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(DesktopLocaleSelector),
          _createVNode(ContentBanner, {
            title: pageTitle.value,
            message: _ctx.$t('tools.bannerWelcomeText'),
            imagePath: require('@/assets/em-toolsGuide-banner.svg'),
            imageWidthDesktop: "180px",
            imageMarginLeftDesktop: "35px",
            "data-test": "tools-banner"
          }, null, 8, ["title", "message", "imagePath"]),
          _createElementVNode("div", _hoisted_1, [
            (
            _unref(featureFlagStore).isFlagEnabled('release-component-resume', false)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("resume.title")), 1),
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("resume.description")), 1)
                  ]),
                  _createVNode(CardPortrait, {
                    content: resumeBuilderCTA,
                    statusBadge: _ctx.$t('resume.resumeCard.badgeText'),
                    url: "ResumeOverview",
                    isLoaded: true,
                    "data-test": "resume-cta-card"
                  }, null, 8, ["statusBadge"])
                ]))
              : _createCommentVNode("", true),
            (!isAssessmentsLoaded.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(TitleSkeleton),
                    _createVNode(DescriptionSkeleton)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (index) => {
                      return _createVNode(CardSkeleton, {
                        class: "cards-skeleton",
                        key: index
                      })
                    }), 64))
                  ])
                ]))
              : (assessmentsExist.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t("tools.pageTitle")), 1),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("tools.pageDescription")), 1)
                    ]),
                    _createVNode(AssessmentCards, { "data-test": "assessment-card" })
                  ]))
                : (
            isAssessmentsLoaded.value &&
            !_unref(featureFlagStore).isFlagEnabled('release-component-resume', false)
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t("tools.pageTitleEmpty")), 1),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("tools.pageDescriptionEmpty")), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(AppButton, {
                          size: "default",
                          type: "primary",
                          label: _ctx.$t('tools.returnHome'),
                          ariaLabel: _ctx.$t('tools.returnHome'),
                          "data-test": "tools-home-button",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (
                _ctx.$router.push({
                  name: 'Home',
                })
              ))
                        }, null, 8, ["label", "ariaLabel"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})